import type {Row} from '../../../../hooks/tanstack-table/helpers/types'
import {useTableInstance} from '../../../../hooks/tanstack-table/providers/table-provider'
import type {MemexItemModel} from '../../../../models/memex-item-model'

/**
 * Hook to determine if a row is a sub-issue (nested row).
 * In grouped tables, sub-issues have depth > 1; in non-grouped tables, sub-issues have depth > 0
 */
export const useIsSubIssue = (row: Row<MemexItemModel>): boolean => {
  const table = useTableInstance()
  const hasGroupedRows = !!table.groupedRows?.length
  const isSubIssue = (hasGroupedRows && row.depth > 1) || (row.depth > 0 && !hasGroupedRows)
  return isSubIssue
}
